export default __webpack_public_path__ + "static/media/diagnostic.f1c2ef9b.svg";